/**
 * Label for lesson content that has not had teacher review or content
 * validation (`is_sample_content`, first-learning-journey §6.2). Deliberately
 * plain and separate from the MOCK badge: the content is a sample, but the
 * child's work on it is real.
 */
export const SAMPLE_CONTENT_TEXT = 'Nội dung mẫu — chưa được kiểm duyệt'

export function SampleContentLabel(): React.JSX.Element {
  return (
    <p className="self-center rounded-md border border-slate-400 px-2 py-0.5 text-base text-slate-700 dark:border-slate-500 dark:text-slate-300">
      {SAMPLE_CONTENT_TEXT}
    </p>
  )
}
